"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8926],{

/***/ 68224:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8920);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(28889);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);




var Background = function(param) {
    var _zIndex = param.zIndex, zIndex = _zIndex === void 0 ? -3 : _zIndex, _fixed = param.fixed, fixed = _fixed === void 0 ? true : _fixed;
    var theme = (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        zIndex: zIndex,
        position: fixed ? "fixed" : "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            position: "relative",
            width: "100%",
            height: "100%",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                priority: true,
                src: "/branding/img-background-gamenation".concat(theme.palette.type === "dark" ? "-dark" : "", ".svg"),
                alt: "game nation logo",
                layout: "fill",
                objectFit: "cover"
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Background);


/***/ }),

/***/ 41242:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Loading_LoadingContentCard; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_extends.mjs
var _extends = __webpack_require__(40872);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/makeStyles.js
var makeStyles = __webpack_require__(41120);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Box/Box.js
var Box = __webpack_require__(28889);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
// EXTERNAL MODULE: ./node_modules/@material-ui/lab/esm/Skeleton/Skeleton.js
var Skeleton = __webpack_require__(58365);
;// CONCATENATED MODULE: ./src/components/@common/ContentCard/Loading/variants/ExtraSmall.tsx







var useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return {
        icon: {
            width: 96,
            height: 96,
            marginBottom: theme.spacing(2),
            borderRadius: theme.shape.borderRadius
        }
    };
});
var ExtraSmallLoadingContentCard = function(_param) {
    var props = (0,_extends/* default */.Z)({}, _param);
    var classes = useStyles();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        mx: 1,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                variant: "rect",
                className: classes.icon
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: "subtitle2",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                    variant: "text",
                    width: 96,
                    height: 36
                })
            })
        ]
    }));
};
/* harmony default export */ var ExtraSmall = (ExtraSmallLoadingContentCard);

;// CONCATENATED MODULE: ./src/components/@common/ContentCard/Loading/variants/Large.tsx







var Large_useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return {
        container: {
            padding: "0 !important",
            maxWidth: 328,
            width: "100%",
            height: 257,
            borderRadius: theme.shape.borderRadius,
            backgroundColor: theme.palette.grey[50],
            filter: "drop-shadow(0px 1px 18px rgba(0, 0, 0, 0.12))"
        },
        image: {
            height: 185,
            borderRadius: 4,
            backgroundColor: theme.palette.divider,
            width: "100%"
        },
        content: {
            height: 72,
            width: "100%",
            backgroundColor: theme.palette.primary.contrastText,
            padding: theme.spacing(4),
            borderBottomLeftRadius: theme.shape.borderRadius,
            borderBottomRightRadius: theme.shape.borderRadius
        },
        icon: {
            width: 40,
            height: 40,
            marginRight: theme.spacing(2),
            backgroundColor: theme.palette.grey[300],
            borderRadius: theme.shape.borderRadius
        },
        text: {
            backgroundColor: theme.palette.grey[300]
        }
    };
});
var LargeLoadingContentCard = function(_param) {
    var props = (0,_extends/* default */.Z)({}, _param);
    var classes = Large_useStyles();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: classes.container,
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-end"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                variant: "rect",
                className: classes.image
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                className: classes.content,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                        variant: "rect",
                        className: classes.icon
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "flex-start",
                        width: "auto",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "subtitle2",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                    variant: "text",
                                    width: 150,
                                    className: classes.text
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "subtitle2",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                    variant: "text",
                                    width: "60%",
                                    className: classes.text
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ var Large = (LargeLoadingContentCard);

;// CONCATENATED MODULE: ./src/components/@common/ContentCard/Loading/variants/Medium.tsx







var Medium_useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return {
        container: {
            padding: "0 !important",
            width: 200,
            borderRadius: theme.shape.borderRadius,
            boxShadow: "0px 1px 18px rgba(0, 0, 0, 0.12)"
        },
        image: {
            height: 112,
            borderRadius: theme.shape.borderRadius,
            width: "100%",
            marginBottom: theme.spacing(2)
        },
        icon: {
            width: 40,
            height: 40,
            marginRight: theme.spacing(2),
            borderRadius: theme.shape.borderRadius
        }
    };
});
var MediumLoadingContentCard = function(_param) {
    var props = (0,_extends/* default */.Z)({}, _param);
    var classes = Medium_useStyles();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: classes.container
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                variant: "rect",
                className: classes.image
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                display: "flex",
                flexDirection: "row",
                width: "100%",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                        variant: "rect",
                        className: classes.icon
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "flex-start",
                        width: "auto",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "subtitle2",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                    variant: "text",
                                    width: 150
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "subtitle2",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                    variant: "text",
                                    width: "60%"
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ var Medium = (MediumLoadingContentCard);

;// CONCATENATED MODULE: ./src/components/@common/ContentCard/Loading/variants/Small.tsx







var Small_useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return {
        icon: {
            width: 64,
            height: 64,
            marginRight: theme.spacing(2),
            borderRadius: theme.shape.borderRadius,
            backgroundColor: theme.palette.grey[200]
        }
    };
});
var SmallLoadingContentCard = function(_param) {
    var bgcolor = _param.bgcolor, props = (0,_object_without_properties/* default */.Z)(_param, [
        "bgcolor"
    ]);
    var classes = Small_useStyles();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        display: "flex",
        flexDirection: "row"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                variant: "rect",
                className: classes.icon,
                style: {
                    backgroundColor: bgcolor
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                width: "auto",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "subtitle2",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                            variant: "text",
                            width: 150,
                            style: {
                                backgroundColor: bgcolor
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "subtitle2",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                            variant: "text",
                            width: "60%",
                            style: {
                                backgroundColor: bgcolor
                            }
                        })
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ var Small = (SmallLoadingContentCard);

;// CONCATENATED MODULE: ./src/components/@common/ContentCard/Loading/LoadingContentCard.tsx








var LoadingContentCard = function(_param) {
    var type = _param.type, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "type"
    ]);
    switch(type){
        case "xs":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ExtraSmall, (0,_object_spread/* default */.Z)({}, rest));
        case "sm":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Small, (0,_object_spread/* default */.Z)({}, rest));
        case "md":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Medium, (0,_object_spread/* default */.Z)({}, rest));
        case "lg":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Large, (0,_object_spread/* default */.Z)({}, rest));
    }
};
/* harmony default export */ var Loading_LoadingContentCard = (LoadingContentCard);


/***/ }),

/***/ 63605:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ ContentCardInfo; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41120);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(28889);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(22318);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(282);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var components_common_GameIcon__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(66610);
/* harmony import */ var components_navigation_Link__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(18780);






var useStyles = (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(theme) {
    return {
        button: {
            padding: "0 !important",
            width: 201,
            height: 176,
            boxShadow: "0px 1px 18px rgba(0, 0, 0, 0.12)",
            margin: theme.spacing(4, 1, 4, 1)
        },
        label: {
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            textTransform: "none",
            height: "100%"
        }
    };
});
var ContentCardInfo = function(param) {
    var title = param.title, subTitle = param.subTitle, image = param.image, blurImage = param.blurImage, imagesAboveFold = param.imagesAboveFold;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        width: "100%",
        height: "auto",
        p: 2,
        bgcolor: "background.paper",
        flex: 1,
        children: [
            image && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_common_GameIcon__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                src: image,
                alt: "".concat(subTitle, " icon"),
                blurDataURL: blurImage,
                imagesAboveFold: imagesAboveFold
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                width: "100%",
                overflow: "hidden",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        whiteSpace: "nowrap",
                        textOverflow: "ellipsis",
                        overflow: "hidden",
                        textAlign: "left",
                        clone: true,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                            variant: "subtitle1",
                            component: "span",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("b", {
                                children: title
                            })
                        })
                    }),
                    subTitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        whiteSpace: "nowrap",
                        textOverflow: "ellipsis",
                        overflow: "hidden",
                        textAlign: "left",
                        width: "100%",
                        clone: true,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                            variant: "subtitle2",
                            color: "textSecondary",
                            component: "span",
                            children: subTitle
                        })
                    })
                ]
            })
        ]
    });
};
var ContentCardMedium = function(param) {
    var title = param.title, subTitle = param.subTitle, bannerImage = param.bannerImage, image = param.image, blurImage = param.blurImage, onClick = param.onClick, href = param.href, imagesAboveFold = param.imagesAboveFold;
    var classes = useStyles();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
        component: href ? components_navigation_Link__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .C : "button",
        href: href,
        classes: {
            root: classes.button,
            label: classes.label
        },
        onClick: href ? undefined : onClick,
        "data-testid": "game",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                width: "100%",
                height: 112,
                position: "relative",
                overflow: "hidden",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                    src: bannerImage,
                    alt: "".concat(title, " image"),
                    layout: "fill",
                    objectFit: "cover",
                    blurDataURL: blurImage,
                    placeholder: "blur",
                    priority: imagesAboveFold
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ContentCardInfo, {
                title: title,
                subTitle: subTitle,
                image: image,
                blurImage: blurImage,
                imagesAboveFold: imagesAboveFold
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ContentCardMedium);


/***/ }),

/***/ 71074:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41120);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69685);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(58108);



var useStyles = (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(theme) {
    return {
        imageList: {
            flexWrap: "nowrap",
            // Promote the list into his own layer on Chrome. This cost memory but helps keeping high FPS.
            transform: "translateZ(0)"
        },
        imageListNoPadding: {
            flexWrap: "nowrap",
            // Promote the list into his own layer on Chrome. This cost memory but helps keeping high FPS.
            transform: "translateZ(0)"
        },
        imageListItem: {
            width: "auto !important",
            padding: "0 !important"
        },
        firstImage: {
            "& a": {
                marginLeft: theme.spacing(4)
            }
        },
        lastImage: {
            "& a": {
                marginRight: theme.spacing(4)
            }
        }
    };
});
var HorizontalList = function(param) {
    var children = param.children, id = param.id, _omitPadding = param.omitPadding, omitPadding = _omitPadding === void 0 ? false : _omitPadding;
    var classes = useStyles();
    var items = react__WEBPACK_IMPORTED_MODULE_1__.Children.toArray(children);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        className: omitPadding ? classes.imageListNoPadding : classes.imageList,
        rowHeight: "auto",
        gap: 8,
        children: items.map(function(child, key) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                classes: {
                    root: classes.imageListItem
                },
                className: key === 0 ? classes.firstImage : key === items.length - 1 ? classes.lastImage : undefined,
                children: typeof child === "string" || typeof child === "number" ? child : /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.cloneElement(child)
            }, "".concat(id, "-").concat(key));
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (HorizontalList);


/***/ }),

/***/ 78670:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(28889);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(22318);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(282);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(44012);
/* harmony import */ var components_common_ContentCard_Loading_LoadingContentCard__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41242);





var SearchEmptyState = function(param) {
    var value = param.value, onClear = param.onClear;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_common_ContentCard_Loading_LoadingContentCard__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                type: "sm",
                mb: 5,
                bgcolor: "grey.300"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_common_ContentCard_Loading_LoadingContentCard__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                type: "sm",
                mb: 6,
                bgcolor: "grey.300"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                variant: "h5",
                component: "h1",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                    id: "discover.search.empty.title"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                mt: 2,
                mb: 4,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    variant: "body1",
                    color: "textSecondary",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        id: "discover.search.empty.description",
                        values: {
                            value: value
                        }
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                onClick: onClear,
                variant: "outlined",
                fullWidth: true,
                color: "primary",
                size: "medium",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                    id: "discover.search.empty.button"
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SearchEmptyState);


/***/ }),

/***/ 38825:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(98123);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(7397);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(17812);
/* harmony import */ var _material_ui_core_styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41120);
/* harmony import */ var _material_ui_icons_Close__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(80366);
/* harmony import */ var _material_ui_icons_Search__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(88995);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86896);









var useStyles = (0,_material_ui_core_styles__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(theme) {
    return {
        root: {
            borderRadius: theme.spacing(1)
        },
        input: {
            border: "1px solid ".concat(theme.states.primary.outlinedHover),
            backgroundColor: theme.states.primary.outlinedHover
        },
        icon: {
            color: theme.palette.text.secondary
        },
        adornedEnd: {
            paddingRight: theme.spacing(2)
        }
    };
});
var SearchInput = function(_param) {
    var value = _param.value, onChange = _param.onChange, onClear = _param.onClear, _variant = _param.variant, variant = _variant === void 0 ? "outlined" : _variant, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "value",
        "onChange",
        "onClear",
        "variant"
    ]);
    var classes = useStyles();
    var intl = (0,react_intl__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        variant: variant,
        color: "primary",
        className: classes.root,
        value: value,
        size: "small",
        placeholder: intl.formatMessage({
            id: "input.search.placeholder"
        }),
        onChange: onChange,
        InputProps: {
            startAdornment: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                position: "start",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_icons_Search__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                    className: classes.icon
                })
            }),
            endAdornment: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: !!value && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                    position: "end",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                        onClick: function() {
                            return onClear();
                        },
                        hidden: true,
                        size: "small",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_icons_Close__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                            className: classes.icon
                        })
                    })
                })
            }),
            classes: {
                notchedOutline: classes.input,
                adornedEnd: classes.adornedEnd
            }
        }
    }, rest));
};
/* harmony default export */ __webpack_exports__["Z"] = (SearchInput);


/***/ }),

/***/ 65943:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Section_GameSection; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Box/Box.js
var Box = __webpack_require__(28889);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/List/List.js
var List = __webpack_require__(62822);
// EXTERNAL MODULE: ./src/hooks/auth/useAuth.ts
var useAuth = __webpack_require__(22291);
// EXTERNAL MODULE: ./src/hooks/useAnalytics.ts
var useAnalytics = __webpack_require__(79450);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(86896);
// EXTERNAL MODULE: ./src/routes.ts
var routes = __webpack_require__(68711);
// EXTERNAL MODULE: ./src/utils/game.utils.ts
var game_utils = __webpack_require__(62698);
// EXTERNAL MODULE: ./src/utils/routes.utils.ts
var routes_utils = __webpack_require__(24039);
// EXTERNAL MODULE: ./src/constants/blurBase64.ts
var blurBase64 = __webpack_require__(56278);
// EXTERNAL MODULE: ./src/constants/events.ts
var events = __webpack_require__(19910);
// EXTERNAL MODULE: ./src/services/api/definitions/game.definitions.ts
var game_definitions = __webpack_require__(45362);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/makeStyles.js
var makeStyles = __webpack_require__(41120);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Button/Button.js
var Button = __webpack_require__(282);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/components/@navigation/Link/Link.tsx
var Link = __webpack_require__(18780);
;// CONCATENATED MODULE: ./src/components/@common/ContentCard/ExtraSmall/ContentCardExtraSmall.tsx





var useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return {
        root: {
            display: "-webkit-box",
            "-webkit-box-orient": "vertical",
            "-webkit-line-clamp": 2,
            overflow: "hidden",
            height: "38px"
        },
        label: {
            display: "flex",
            flexDirection: "column",
            width: "96px",
            textTransform: "none",
            textAlign: "left"
        },
        button: {
            padding: 0,
            height: "100%",
            margin: theme.spacing(0, 1)
        }
    };
});
var ContentCardExtraSmall = function(param) {
    var title = param.title, image = param.image, blurImage = param.blurImage, href = param.href, imagesAboveFold = param.imagesAboveFold;
    var classes = useStyles();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
        classes: {
            label: classes.label,
            root: classes.button
        },
        component: href ? Link/* default */.C : "button",
        href: href,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                borderRadius: 12,
                width: "100%",
                height: 96,
                position: "relative",
                overflow: "hidden",
                mb: 2,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: image,
                    alt: "".concat(title, " image"),
                    layout: "fill",
                    objectFit: "cover",
                    blurDataURL: blurImage,
                    placeholder: "blur",
                    priority: imagesAboveFold
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                classes: {
                    root: classes.root
                },
                variant: "subtitle2",
                component: "h2",
                children: title
            })
        ]
    });
};
/* harmony default export */ var ExtraSmall_ContentCardExtraSmall = (ContentCardExtraSmall);

// EXTERNAL MODULE: ./src/components/@common/ContentCard/Medium/ContentCardMedium.tsx
var ContentCardMedium = __webpack_require__(63605);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/ListItem/ListItem.js
var ListItem = __webpack_require__(50998);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/ListItemIcon/ListItemIcon.js
var ListItemIcon = __webpack_require__(46869);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/ListItemText/ListItemText.js
var ListItemText = __webpack_require__(95757);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/ListItemSecondaryAction/ListItemSecondaryAction.js
var ListItemSecondaryAction = __webpack_require__(81860);
;// CONCATENATED MODULE: ./src/components/@common/ContentCard/Small/ContentCardSmall.tsx





var ContentCardSmall_useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return {
        listItem: {
            paddingTop: 0,
            paddingBottom: 0,
            marginBottom: theme.spacing(2),
            paddingRight: 120
        },
        listItemSecondaryAction: {
            right: 0
        }
    };
});
var ContentCardSmall = function(param) {
    var title = param.title, subTitle = param.subTitle, image = param.image, buttonText = param.buttonText, explainerText = param.explainerText, blurImage = param.blurImage, href = param.href, imagesAboveFold = param.imagesAboveFold, disableAction = param.disableAction, onActionClick = param.onActionClick, onClick = param.onClick;
    var classes = ContentCardSmall_useStyles();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ListItem/* default */.Z, {
        className: classes.listItem,
        button: true,
        component: Link/* default */.C,
        href: href,
        "data-testid": "game",
        disableGutters: true,
        onClick: onClick,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemIcon/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    borderRadius: 12,
                    width: 64,
                    height: 64,
                    position: "relative",
                    overflow: "hidden",
                    mr: 3,
                    flexShrink: 0,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: image,
                        alt: "".concat(title, " image"),
                        layout: "fill",
                        objectFit: "cover",
                        blurDataURL: blurImage,
                        placeholder: "blur",
                        priority: imagesAboveFold
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ListItemText/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        whiteSpace: "nowrap",
                        textOverflow: "ellipsis",
                        overflow: "hidden",
                        width: "100%",
                        clone: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "subtitle1",
                            component: "p",
                            children: title
                        })
                    }),
                    subTitle && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "subtitle2",
                        component: "span",
                        color: "textSecondary",
                        children: subTitle
                    })
                ]
            }),
            onActionClick && /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemSecondaryAction/* default */.Z, {
                className: classes.listItemSecondaryAction,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "flex-end",
                    ml: 2,
                    flexShrink: 0,
                    flexGrow: 1,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            variant: "outlined",
                            color: "primary",
                            onClick: onActionClick,
                            size: "small",
                            disabled: disableAction,
                            children: buttonText
                        }),
                        explainerText && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "caption",
                            color: "textSecondary",
                            children: explainerText
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var Small_ContentCardSmall = (ContentCardSmall);

// EXTERNAL MODULE: ./src/components/@common/HorizontalList/HorizontalList.tsx
var HorizontalList = __webpack_require__(71074);
;// CONCATENATED MODULE: ./src/components/@game-detail/Section/GameSection.tsx
















var GameSection = function(param) {
    var data = param.data, _variant = param.variant, variant = _variant === void 0 ? "large" : _variant, id = param.id, imagesAboveFold = param.imagesAboveFold, _disablePadding = param.disablePadding, disablePadding = _disablePadding === void 0 ? false : _disablePadding, onClickItem = param.onClickItem;
    var intl = (0,useIntl/* default */.Z)();
    var router = (0,next_router.useRouter)();
    var isLoggedIn = (0,useAuth/* useAuth */.a)().isLoggedIn;
    var send = (0,useAnalytics/* useAnalytics */.z)().send;
    if (variant === "detail") {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
            mx: disablePadding ? 0 : 4,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(List/* default */.Z, {
                children: data.map(function(game) {
                    var gamePrice = game.price.toLowerCase() === "free" ? intl.formatMessage({
                        id: "game.details.price.free"
                    }) : game.price;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Small_ContentCardSmall, {
                        title: game.name,
                        subTitle: game.collectionName,
                        image: game.smallTeaserImage,
                        buttonText: (0,game_utils/* isExternalGameProvider */.eP)(game.provider) ? intl.formatMessage({
                            id: "game.action.view"
                        }) : gamePrice,
                        blurImage: blurBase64/* default */.Z,
                        explainerText: game.subscriptionType === game_definitions/* SubscriptionType.oneTimePurchase */.Qe.oneTimePurchase ? intl.formatMessage({
                            id: "game.explainer_text.one_time_pay"
                        }) : intl.formatMessage({
                            id: "game.explainer_text.per_game_session"
                        }) // TODO: add all cases
                        ,
                        onClick: function() {
                            return onClickItem === null || onClickItem === void 0 ? void 0 : onClickItem(game);
                        },
                        onActionClick: game.contentType === game_definitions/* ContentType.game */.zc.game && (0,game_utils/* canPlayGame */.IS)(game) ? function() {
                            if (!(0,game_utils/* isExternalGameProvider */.eP)(game.provider)) {
                                send({
                                    event: events/* Events.gamePlayed */.z.gamePlayed,
                                    data: {
                                        game: {
                                            slug: game === null || game === void 0 ? void 0 : game.slugName
                                        }
                                    },
                                    withUser: true
                                });
                            }
                            router.push((0,routes_utils/* generatePath */.G)((0,game_utils/* isExternalGameProvider */.eP)(game.provider) ? routes/* Routes.gameDetails */.Z.gameDetails : routes/* Routes.game */.Z.game, {
                                slug: game.slugName
                            }));
                        } : undefined,
                        href: (0,routes_utils/* generatePath */.G)(routes/* Routes.gameDetails */.Z.gameDetails, {
                            slug: game.slugName
                        }),
                        imagesAboveFold: imagesAboveFold,
                        disableAction: !isLoggedIn
                    }, game.id);
                })
            })
        });
    }
    if (variant === "small") {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(HorizontalList/* default */.Z, {
            id: id,
            omitPadding: disablePadding,
            children: data.map(function(game) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ExtraSmall_ContentCardExtraSmall, {
                    title: game.name,
                    image: game.smallTeaserImage,
                    blurImage: blurBase64/* default */.Z,
                    href: (0,routes_utils/* generatePath */.G)(routes/* Routes.gameDetails */.Z.gameDetails, {
                        slug: game.slugName
                    }),
                    imagesAboveFold: imagesAboveFold
                }, game.id);
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(HorizontalList/* default */.Z, {
        id: id,
        omitPadding: disablePadding,
        children: data.map(function(game, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentCardMedium/* default */.Z, {
                title: game.name,
                subTitle: game.collectionName,
                bannerImage: game.largeTeaserImage,
                image: game.smallTeaserImage,
                blurImage: blurBase64/* default */.Z,
                href: (0,routes_utils/* generatePath */.G)(routes/* Routes.gameDetails */.Z.gameDetails, {
                    slug: game.slugName
                }),
                imagesAboveFold: imagesAboveFold && index < 3
            }, game.id);
        })
    });
};
/* harmony default export */ var Section_GameSection = (GameSection);


/***/ }),

/***/ 14357:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony exports StyledButtton, PrimaryButton */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(282);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(28889);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(22318);
/* harmony import */ var _material_ui_lab__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(58365);
/* harmony import */ var hooks__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(22291);
/* harmony import */ var hooks__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(79450);
/* harmony import */ var hooks_mounted__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(18063);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11752);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_config__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(44012);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(29430);
/* harmony import */ var constants_events__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(19910);
/* harmony import */ var components_navigation_Link__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(18780);




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 15px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  line-height: 16px;\n  height: 100%;\n  min-height: 42px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}













var ref = next_config__WEBPACK_IMPORTED_MODULE_3___default()(), config = ref.publicRuntimeConfig;
var StyledButtton = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(_material_ui_core__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_templateObject());
var PrimaryButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(_material_ui_core__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_templateObject1());
var NotLoggedInCta = function(_param) {
    var icon = _param.icon, title = _param.title, description = _param.description, _textAlign = _param.textAlign, textAlign = _textAlign === void 0 ? "left" : _textAlign, _titleVariant = _param.titleVariant, titleVariant = _titleVariant === void 0 ? "h4" : _titleVariant, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_param, [
        "icon",
        "title",
        "description",
        "textAlign",
        "titleVariant"
    ]);
    var isMounted = (0,hooks_mounted__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)();
    var isLoggedIn = (0,hooks__WEBPACK_IMPORTED_MODULE_9__/* .useAuth */ .a)().isLoggedIn;
    var pathname = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)().pathname;
    var send = (0,hooks__WEBPACK_IMPORTED_MODULE_10__/* .useAnalytics */ .z)().send;
    if (isLoggedIn) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_material_ui_core__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({
        textAlign: textAlign,
        width: "100%"
    }, rest), {
        children: [
            icon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                color: "grey.100",
                pb: 2,
                children: icon
            }),
            title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                children: !isMounted ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                    pb: 2,
                    height: 50,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_lab__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                        variant: "text",
                        width: "60%",
                        height: 42
                    })
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                    pb: 2,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                        variant: titleVariant,
                        component: "h1",
                        color: "textPrimary",
                        children: title
                    })
                })
            }),
            description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                children: !isMounted ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                    height: {
                        xs: 48,
                        md: 24
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_lab__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                        variant: "text",
                        height: "inherit",
                        width: "100%"
                    })
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                    variant: "body1",
                    color: "textSecondary",
                    children: description
                })
            }),
            !isMounted ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                mt: 4,
                mb: 2,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_lab__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                    variant: "text",
                    width: "100%",
                    height: 42
                })
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                mt: 4,
                mb: 2,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(PrimaryButton, {
                    //@ts-ignore
                    component: components_navigation_Link__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .C,
                    href: config.DIGI_LOGIN_URL,
                    variant: "contained",
                    color: "primary",
                    fullWidth: true,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                        id: "home.account.intro.login.button"
                    })
                })
            }),
            !isMounted ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                display: "flex",
                justifyContent: "center",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_lab__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                    width: "80%",
                    height: 42
                })
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledButtton, {
                //@ts-ignore
                component: components_navigation_Link__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .C,
                href: config.DIGI_REGISTER_URL,
                variant: "text",
                color: "primary",
                fullWidth: true,
                onClick: function() {
                    return send({
                        event: constants_events__WEBPACK_IMPORTED_MODULE_18__/* .Events.startRegistration */ .z.startRegistration,
                        data: {
                            channel: pathname
                        }
                    });
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                    id: "home.account.intro.create_account.button"
                })
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["ZP"] = (NotLoggedInCta);


/***/ }),

/***/ 17854:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45258);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(28358);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(28889);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(17812);
/* harmony import */ var _material_ui_icons_ArrowBack__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69826);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var components_navigation_ElevationScroll__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47501);






var HeaderSimple = function(param) {
    var onBackClick = param.onBackClick, rightItems = param.rightItems, _noBack = param.noBack, noBack = _noBack === void 0 ? false : _noBack;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var handleGoBack = function() {
        router.back();
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_navigation_ElevationScroll__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    color: "default",
                    elevation: 0,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        variant: "dense",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                            display: "flex",
                            justifyContent: "space-between",
                            width: "100%",
                            alignItems: "center",
                            children: [
                                !noBack && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                    color: "text.primary",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                        edge: "start",
                                        "aria-label": "back",
                                        color: "inherit",
                                        onClick: onBackClick !== null && onBackClick !== void 0 ? onBackClick : handleGoBack,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_icons_ArrowBack__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {})
                                    })
                                }),
                                rightItems !== undefined && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                    display: "flex",
                                    justifyContent: "flex-end",
                                    width: "100%",
                                    children: rightItems
                                })
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                height: 56,
                flexShrink: 0
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (HeaderSimple);


/***/ }),

/***/ 51222:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ Games; },
/* harmony export */   "_": function() { return /* binding */ GAME_PROVIDER_SHORTCODES; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14924);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var services_api_definitions_game_definitions__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45362);





var ExternalGame = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return __webpack_require__.e(/* import() */ 327).then(__webpack_require__.bind(__webpack_require__, 60487));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(60487)
            ];
        }
    }
});
var Raffle = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9416), __webpack_require__.e(7554), __webpack_require__.e(8336)]).then(__webpack_require__.bind(__webpack_require__, 78336));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(78336)
            ];
        }
    }
});
var ScratchAndWin = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9416), __webpack_require__.e(7554), __webpack_require__.e(9735), __webpack_require__.e(8317)]).then(__webpack_require__.bind(__webpack_require__, 28317));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(28317)
            ];
        }
    }
});
var Trivia = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9416), __webpack_require__.e(5419), __webpack_require__.e(7935), __webpack_require__.e(4231), __webpack_require__.e(7554), __webpack_require__.e(302), __webpack_require__.e(6079)]).then(__webpack_require__.bind(__webpack_require__, 86079));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(86079)
            ];
        }
    }
});
var Voting = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9416), __webpack_require__.e(7935), __webpack_require__.e(7554), __webpack_require__.e(8670)]).then(__webpack_require__.bind(__webpack_require__, 20935));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(20935)
            ];
        }
    }
});
var SlotMachine = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9416), __webpack_require__.e(7554), __webpack_require__.e(3680), __webpack_require__.e(7971)]).then(__webpack_require__.bind(__webpack_require__, 27971));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(27971)
            ];
        }
    }
});
// TODO: enable when games are available
// const SpinTheWheel = dynamic(() => import('components/@game/InternalGame/SpinTheWheel'));
var Games = function(game) {
    switch(game.type){
        case services_api_definitions_game_definitions__WEBPACK_IMPORTED_MODULE_3__/* .TypeOfGame.scratch */ .f2.scratch:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ScratchAndWin, {
                game: game
            });
        case services_api_definitions_game_definitions__WEBPACK_IMPORTED_MODULE_3__/* .TypeOfGame.quiz */ .f2.quiz:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Trivia, {
                id: game.id,
                slug: game.slugName
            });
        case services_api_definitions_game_definitions__WEBPACK_IMPORTED_MODULE_3__/* .TypeOfGame.vote */ .f2.vote:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Voting, {
                id: game.id,
                slug: game.slugName
            });
        case services_api_definitions_game_definitions__WEBPACK_IMPORTED_MODULE_3__/* .TypeOfGame.raffle */ .f2.raffle:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Raffle, {
                id: game.id,
                slug: game.slugName
            });
        case services_api_definitions_game_definitions__WEBPACK_IMPORTED_MODULE_3__/* .TypeOfGame.slot */ .f2.slot:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SlotMachine, {
                id: game.id,
                slug: game.slugName
            });
        // case TypeOfGame.wheel:
        //   return <SpinTheWheel id={game.id} slug={game.slugName} />;
        case services_api_definitions_game_definitions__WEBPACK_IMPORTED_MODULE_3__/* .TypeOfGame.webview */ .f2.webview:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ExternalGame, {
                game: game
            });
        default:
            return null;
    }
};
var _obj;
var GAME_PROVIDER_SHORTCODES = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, services_api_definitions_game_definitions__WEBPACK_IMPORTED_MODULE_3__/* .GameProvider.Newcom */ .Ui.Newcom, ""), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, services_api_definitions_game_definitions__WEBPACK_IMPORTED_MODULE_3__/* .GameProvider.Gameloft */ .Ui.Gameloft, "18764442404"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, services_api_definitions_game_definitions__WEBPACK_IMPORTED_MODULE_3__/* .GameProvider.Nazara */ .Ui.Nazara, "18764442484"), _obj);


/***/ }),

/***/ 11836:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useQueryString; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41609);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lodash_pickBy__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35937);
/* harmony import */ var lodash_pickBy__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_pickBy__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(80129);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(qs__WEBPACK_IMPORTED_MODULE_3__);





function useQueryString() {
    var ref = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)(), push = ref.push, asPath = ref.asPath;
    var ref1;
    var parsedQuery = (0,qs__WEBPACK_IMPORTED_MODULE_3__.parse)((ref1 = asPath.split("?").pop()) !== null && ref1 !== void 0 ? ref1 : "");
    var setQuery = function(values) {
        var newQuery = lodash_pickBy__WEBPACK_IMPORTED_MODULE_1___default()((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, parsedQuery, values));
        var ref;
        var path = lodash_isEmpty__WEBPACK_IMPORTED_MODULE_0___default()(newQuery) ? (ref = asPath.split("?").shift()) !== null && ref !== void 0 ? ref : "" : "".concat(asPath.split("?").shift(), "?").concat((0,qs__WEBPACK_IMPORTED_MODULE_3__.stringify)(newQuery));
        push(path, undefined, {
            shallow: true
        });
    };
    var ref2;
    return [
        (0,qs__WEBPACK_IMPORTED_MODULE_3__.parse)((ref2 = asPath.split("?").pop()) !== null && ref2 !== void 0 ? ref2 : ""),
        setQuery
    ];
}


/***/ }),

/***/ 1470:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "G": function() { return /* binding */ useSimpleSearch; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/hooks/query/useQueryString.ts
var useQueryString = __webpack_require__(11836);
// EXTERNAL MODULE: ./node_modules/lodash/debounce.js
var debounce = __webpack_require__(23279);
var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce);
;// CONCATENATED MODULE: ./src/constants/urlParams.ts
var urlParams = {
    search: "search"
};

;// CONCATENATED MODULE: ./src/hooks/search/useSimpleSearch.ts







var useSimpleSearch = function() {
    var ref = (0,_sliced_to_array/* default */.Z)((0,useQueryString/* default */.Z)(), 2), query = ref[0], setQuery = ref[1];
    var initialValue = query[urlParams.search] ? String(query[urlParams.search]) : "";
    var ref1 = (0,react.useState)(initialValue), currentValue = ref1[0], setCurrentValue = ref1[1];
    var ref2 = (0,react.useState)(initialValue), debouncedValue = ref2[0], setDebouncedValue = ref2[1];
    var searchDebounce = (0,react.useMemo)(function() {
        return debounce_default()(function(value) {
            return setDebouncedValue(value);
        }, 500);
    }, []);
    var handleSearchChange = (0,react.useCallback)(function(e) {
        setCurrentValue(e.target.value);
        searchDebounce(e.target.value);
        setQuery((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, query), {
            search: e.target.value
        }));
    }, [
        query,
        searchDebounce,
        setQuery
    ]);
    var handleSearchClear = (0,react.useCallback)(function() {
        setCurrentValue("");
        setDebouncedValue("");
        setQuery((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, query), {
            search: undefined
        }));
    }, [
        query,
        setQuery
    ]);
    return {
        currentValue: currentValue,
        debouncedValue: debouncedValue,
        searchClear: handleSearchClear,
        searchChange: handleSearchChange
    };
};


/***/ }),

/***/ 62698:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "IS": function() { return /* binding */ canPlayGame; },
/* harmony export */   "eP": function() { return /* binding */ isExternalGameProvider; },
/* harmony export */   "iU": function() { return /* binding */ getGameProviderShortcode; }
/* harmony export */ });
/* harmony import */ var constants_games__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51222);
/* harmony import */ var services_api_definitions_game_definitions__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(45362);


var canPlayGame = function(param) {
    var type = param.type, url = param.url;
    // Do not show a play button when api decides to leave out the url...
    if (Object.values(services_api_definitions_game_definitions__WEBPACK_IMPORTED_MODULE_0__/* .TypeOfGame */ .f2).includes(type)) {
        return true;
    }
    return Boolean(url);
};
var isExternalGameProvider = function(provider) {
    return provider ? [
        services_api_definitions_game_definitions__WEBPACK_IMPORTED_MODULE_0__/* .GameProvider.Gameloft */ .Ui.Gameloft,
        services_api_definitions_game_definitions__WEBPACK_IMPORTED_MODULE_0__/* .GameProvider.Nazara */ .Ui.Nazara
    ].includes(provider) : false;
};
var getGameProviderShortcode = function(provider) {
    return provider ? constants_games__WEBPACK_IMPORTED_MODULE_1__/* .GAME_PROVIDER_SHORTCODES */ ._[provider] : undefined;
};


/***/ }),

/***/ 24039:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ generatePath; }
/* harmony export */ });
/* unused harmony export enhancePathsWithLocales */
/* harmony import */ var path_to_regexp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(51068);

var cache = {};
var cacheLimit = 10000;
var cacheCount = 0;
function compilePath(path) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    // Keep cache of PathFunctions
    if (cache[path]) return cache[path];
    var generator = (0,path_to_regexp__WEBPACK_IMPORTED_MODULE_0__/* .compile */ .MY)(path, options);
    if (cacheCount < cacheLimit) {
        // populate cache
        cache[path] = generator;
        cacheCount++;
    }
    return generator;
}
/**
 * Generates a valid path you can use for manually pushing to routes.
 * e.g. "/users/:id" > generatePath("/users/:id", { id: 1 }) > "/users/1"
 */ function generatePath() {
    var path = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "/", params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return path === "/" ? path : compilePath(path)(params);
}
function enhancePathsWithLocales(paths, locales) {
    if (!locales) {
        return paths;
    }
    var localePaths = [];
    paths.forEach(function(p) {
        locales.forEach(function(l) {
            localePaths.push({
                params: p.params,
                locale: l
            });
        });
    });
    return localePaths;
}


/***/ })

}]);